/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useChangePasswordStyles = makeStyles(() => ({
  title: {
    margin: '0 0 16px 0',
  },
}));
export const useChangePasswordFormStyles = makeStyles(theme => ({
  form: {
    width: '100%',
    maxWidth: '360px',
  },
  buttons: {
    display: 'flex',
    margin: '0 -8px',
    padding: '40px 0',
  },
  buttonWrap: {
    padding: '0 8px',
  },
  errorBlock: {
    fontSize: '15px',
    lineHeight: '16px',
    padding: '0 19px',
    color: theme.palette.error.main,
    marginTop: '16px',
  },
}));
